import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useMemo} from 'react'
import {useSelector} from 'react-redux'

import {
  banner_item,
  bet_detail_item,
  bet_status_enum,
  history_result_item,
  JackPot_page_enum,
  pokers_list_item,
  PosIdEnum,
  seat_list_item,
  seat_type_enum,
  StatusEnum,
  win_list_item,
  winner_type,
} from './interface'

// 主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96446525
export const tp_homepage = createAsyncThunk(
  'tp_homepage',
  async (arg: {room_id: number; isMulti?: boolean}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'bet_chips'
          | 'my_balance'
          | 'my_icon'
          | 'my_win'
          | 'repeat_enable'
          | 'round_status'
          | 'seat_list'
          | 'pokers_list'
          | 'status_expire'
          | 'round_no'
          | 'jackpot_enable'
          | 'jackpot'
          | 'my_nick_name'
          | 'jackpot_date_range'
          | 'greedy_min_bet'
        >
      >
    >(
      '/live/ground/pt_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 用户退出页面 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96448271
export const tp_exit_game_page = createAsyncThunk(
  'tp_exit_game_page',
  async (arg: {room_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'err_msg'>>>(
      '/live/ground/pt_exit_game_page',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        store,
      }
    )
    return resp.data.data
  }
)
// 下注接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96446573
export const tp_bet = createAsyncThunk(
  'tp_bet',
  async (
    arg: {
      room_id: number
      bet_chip?: number
      bet_pos?: number
      repeated: boolean
      from: string
    },
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'err_msg' | 'status' | 'bet_info' | 'balance'
        > & {
          jackpot_reward: number
        }
      >
    >(
      '/live/ground/pt_bet',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 下注轮次结果 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96446613
export const tp_round_result = createAsyncThunk(
  'tp_round_result',
  async (
    arg: {
      round_no: string
    },
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'err_msg'
          | 'win_list'
          | 'my_win'
          | 'my_bet'
          | 'round_no'
          | 'pokers_list'
        >
      >
    >(
      '/live/ground/pt_round_result',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {store}
    )
    return resp.data.data
  }
)
// 菠菜游戏活动banner http://wiki.xunlei.cn/pages/viewpage.action?pageId=96440123
export const tp_banner_list = createAsyncThunk(
  'tp_banner_list',
  // game_type 2: teen patti
  async (arg: {game_type: 2}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'banner_list'>>
    >(
      '/live/ground/banner_list',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {store}
    )
    return resp.data.data
  }
)
interface InitialStateType {
  err_msg?: string
  chipType?: number
  bet_chips?: number[]
  my_nick_name?: string
  my_balance?: number
  my_icon?: string
  my_win?: number
  round_no?: string
  history_results?: history_result_item[]
  // 是否可以重复上次下注信息
  repeat_enable?: boolean
  // 切换status的时候保留上一次status的状态
  pre_round_status?: StatusEnum
  round_status?: StatusEnum
  // 坐席信息
  seat_list?: seat_list_item[]
  // 扑克牌面信息
  pokers_list?: pokers_list_item[]
  // 当前阶段倒计时
  status_expire?: number
  // 下注返回数据
  balance?: number
  status?: bet_status_enum
  bet_info?: {bet_pos: PosIdEnum; bet_chips: bet_detail_item[]}[]
  // 获取轮次的中奖结果
  win_list?: win_list_item[]
  my_bet?: number
  // 开奖状态回传的数据
  bet_pos_infos?: pokers_list_item[]
  pre_regal_name?: string
  // 富豪位变化前的头像
  pre_regal_icon?: string
  // 活动相关banner
  banner_list?: banner_item[]
  JackPotPage?: JackPot_page_enum
  // jackpot余额
  jackpot?: number
  // jackpot活动是否进行中 如果不是进行中就不展示对应的标志
  jackpot_enable?: boolean
  // jackpot活动有效时间范围,eg: [09.20,09.30]
  jackpot_date_range?: string[]
  // 最小下注
  greedy_min_bet?: {
    price?: number
    countdown?: number
  }
  jackpot_winner?: winner_type
  my_bet_list?: {pos_id: number; my_bets: number}[]
  // 页面是否在加载中
  isLoad?: boolean
  // 前置流程完成标记
  hasPreLoadedAct?: boolean
}

const initialState: InitialStateType = {}

const initData: InitialStateType = {
  isLoad: true,
  hasPreLoadedAct: false,
  JackPotPage: JackPot_page_enum.num,
  // jackpot_winner: {
  //   ct: 0,
  //   bet_coins: 100,
  //   bet_user_name: 'aaa aaa aaa aaa aaa aaa',
  //   bet_user_avatar: 'bbb',
  //   jackpot_reward: 999,
  // },
}

export const TeenPattiSlice = createSlice({
  name: 'TeenPatti',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    // 前置流程完成标记
    finishedPreLoadedAct: (state) => {
      Object.assign(state, {
        hasPreLoadedAct: true,
      })
    },
    // 引擎加载完毕之后隐藏加载页面
    hideLoadPage: (state, action) => {
      Object.assign(state, {
        isLoad: false,
      })
    },
    // 弹幕播放完毕了之后重置jackpot_winner
    resetJackpotWinner: (state, action) => {
      Object.assign(state, {
        jackpot_winner: null,
      })
    },
    // 将当前局的jackPot中奖人固定在左2的位置
    showJackpotWinner: (
      state,
      action: PayloadAction<{
        winner: seat_list_item
      }>
    ) => {
      const {winner} = action.payload
      const {seat_list} = state
      seat_list[2] = {...seat_list[2], ...winner}
      Object.assign(state, {
        seat_list,
      })
    },
    meGetJackpot: (
      state,
      action: PayloadAction<{
        bet_details: Array<{
          bet_chips: bet_detail_item[]
          bet_pos: PosIdEnum
        }>
        bet_user_name: string
        bet_user_avatar: string
        jackpot_reward: number
      }>
    ) => {
      const {bet_details, bet_user_name, bet_user_avatar, jackpot_reward} =
        action.payload
      let bet_coins = 0
      bet_details?.forEach((b) => {
        bet_coins += b.bet_chips.reduce(
          (a, c) => a + c.chip_num * c.chip_value,
          0
        )
      })
      // const {jackpot} = action.payload
      Object.assign(state, {
        jackpot_winner: {
          ct: new Date().getTime(),
          bet_coins,
          bet_user_name,
          bet_user_avatar,
          jackpot_reward,
        },
      })
    },

    whoGetJackpot: (
      state,
      action: PayloadAction<{
        bet_details: Array<{
          chip_list: bet_detail_item[]
          bet_pos: PosIdEnum
        }>
        bet_user_name: string
        bet_user_avatar: string
        jackpot_reward: number
      }>
    ) => {
      const {bet_details, bet_user_name, bet_user_avatar, jackpot_reward} =
        action.payload
      let bet_coins = 0
      bet_details?.forEach((b) => {
        bet_coins += b.chip_list.reduce(
          (a, c) => a + c.chip_num * c.chip_value,
          0
        )
      })
      // const {jackpot} = action.payload
      Object.assign(state, {
        jackpot_winner: {
          ct: new Date().getTime(),
          bet_coins,
          bet_user_name,
          bet_user_avatar,
          jackpot_reward,
        },
      })
    },
    updateJackpot: (state, action: PayloadAction<{jackpot: number}>) => {
      const {jackpot} = action.payload
      Object.assign(state, {
        jackpot,
      })
    },
    changeJackPotPage: (
      state,
      action: PayloadAction<{JackPotPage: JackPot_page_enum}>
    ) => {
      const {JackPotPage} = action.payload
      Object.assign(state, {
        JackPotPage,
      })
    },
    clearPreRegal: (state, action) => {
      Object.assign(state, {
        pre_regal_icon: '',
        pre_regal_name: '',
      })
    },
    // webMsg为204的时候要增加对应档位他人下注的信息
    updateBetNum: (
      state,
      action: PayloadAction<{
        bet_details: Array<{chip_list: bet_detail_item[]; bet_pos: PosIdEnum}>
      }>
    ) => {
      const {bet_details} = action.payload
      const {pokers_list} = state
      bet_details?.forEach((b, bIdx) => {
        const pIdx = pokers_list.findIndex((p) => p.pos_id === b.bet_pos)
        b.chip_list.forEach((chip) => {
          pokers_list[pIdx].bet_coins += chip.chip_num * chip.chip_value
        })
      })
    },
    updateRichManMid: (
      state,
      action: PayloadAction<{
        new_regal_mid: number
      }>
    ) => {
      const {new_regal_mid} = action.payload
      const {seat_list} = state
      const regalIdx = seat_list.findIndex(
        (s) => s.seat_type === seat_type_enum.richMan
      )
      if (regalIdx < 0) {
        return
      }
      seat_list[regalIdx].player_mid = new_regal_mid
      Object.assign(state, {
        seat_list,
      })
    },
    updateRichMan: (
      state,
      action: PayloadAction<{
        new_regal_icon: string
        new_regal_name: string
      }>
    ) => {
      const {new_regal_icon, new_regal_name} = action.payload
      const {seat_list} = state
      const regalIdx = seat_list.findIndex(
        (s) => s.seat_type === seat_type_enum.richMan
      )
      if (regalIdx < 0) {
        return
      }
      const pre_regal_icon = seat_list[regalIdx].player_icon
      const pre_regal_name = seat_list[regalIdx].player_name

      seat_list[regalIdx].player_name = new_regal_name
      seat_list[regalIdx].player_icon = new_regal_icon

      Object.assign(state, {
        seat_list,
        pre_regal_icon,
        pre_regal_name,
      })
    },
    changeBetChip: (state, action: PayloadAction<{chipType: number}>) => {
      const {chipType} = action.payload
      Object.assign(state, {
        chipType,
      })
    },
    changeBetStatus: (
      state,
      action: PayloadAction<{
        bet_pos_infos?: pokers_list_item[]
        new_status: StatusEnum
        status_expire: number
      }>
    ) => {
      const {bet_pos_infos = [], new_status, status_expire} = action.payload
      if (new_status === StatusEnum.bet) {
        // 如果webMsg告知目前到了bet状态 说明上个状态是结算状态
        //  为了防止目前的结算动画没有播放完毕 就不做处理了 结算动画播放完毕会重新拉取一次接口
        return
      }
      const {pokers_list} = state

      if (bet_pos_infos?.length) {
        bet_pos_infos.forEach((b, i) => {
          const {my_bets, bet_coins, ...rest} = b
          pokers_list[i] = {...pokers_list[i], ...rest}
        })
      }
      Object.assign(state, {
        round_status: new_status,
        status_expire,
        pokers_list,
      })
    },
    // 回收筹码之后置空
    clearBetNum: (state, action) => {
      const {pokers_list, my_bet_list} = state
      pokers_list?.forEach((p) => {
        // eslint-disable-next-line no-param-reassign
        p.my_bets = 0
        // eslint-disable-next-line no-param-reassign
        p.bet_coins = 0
      })
      my_bet_list?.forEach((mp) => {
        // eslint-disable-next-line no-param-reassign
        mp.my_bets = 0
      })
      Object.assign(state, {
        pokers_list,
        my_bet_list,
      })
    },
  },
  extraReducers: (builder) => {
    // 主页
    builder.addCase(tp_homepage.fulfilled, (state, action) => {
      // 如果是结算阶段轮询的请求就不进行数据更新
      const {isMulti} = action.meta.arg
      const {round_status, pokers_list, bet_chips, greedy_min_bet} =
        action.payload
      if (round_status === StatusEnum.showRes && isMulti) {
        return
      }
      if (greedy_min_bet) {
        bet_chips.unshift(greedy_min_bet.price)
      }
      Object.assign(state, {
        ...action.payload,
        my_bet_list: pokers_list?.map((p) => {
          return {pos_id: p.pos_id, my_bets: p.my_bets}
        }),
        bet_chips,
      })
    })

    // 下注结果要更新最新的pokerList
    builder.addCase(tp_round_result.fulfilled, (state, action) => {
      const {pokers_list} = action.payload
      Object.assign(state, {pokers_list})
    })

    builder.addCase(tp_banner_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(tp_bet.fulfilled, (state, action) => {
      const {balance, bet_info, status} = action.payload
      if (
        status === bet_status_enum.failed ||
        status === bet_status_enum.outOfCoin
      ) {
        return
      }
      const {pokers_list, my_bet_list} = state
      bet_info?.forEach((b, bIdx) => {
        const pIdx = pokers_list.findIndex((p) => p.pos_id === b.bet_pos)
        b.bet_chips.forEach((chip) => {
          pokers_list[pIdx].bet_coins += chip.chip_num * chip.chip_value
          pokers_list[pIdx].my_bets += chip.chip_num * chip.chip_value
          my_bet_list[pIdx].my_bets += chip.chip_num * chip.chip_value
        })
      })
      Object.assign(state, {my_balance: balance, pokers_list})
    })
  },
})

export default TeenPattiSlice.reducer
export const TeenPattiActions = TeenPattiSlice.actions
export const useGameTeenPatti = () => {
  return useSelector((state) => state.Animal_Raven)
}

export const useMySeat = () => {
  const {seat_list, h_m} = useSelector((store) => {
    const {
      env: {deviceinfo},
      Animal_Raven,
    } = store
    return {
      seat_list: Animal_Raven.seat_list,
      h_m: deviceinfo.h_m,
    }
  })
  return useMemo(() => {
    const mySeat = (seat_list || []).find((v) => {
      return v.player_mid === h_m
    })
    return mySeat ? mySeat.seat_id : 0
  }, [seat_list])
}
export const getMySeat = (id): HTMLDivElement => {
  return document.querySelector(`#seat-${id}`)
}
